<template>

    <div>

        <personalized-game-editor-element v-for="(child, index) in element.children" :key="index" v-model="element.children[index]" @input="handleInput" :location="elementLocation"></personalized-game-editor-element>

    </div>

</template>

<script>

export default {

    name: 'PersonalizedGameEditorEditorNode',

    props: {
        value: Object,
        location: String
    },

    data() {
        return {
            element: this.value
        }
    },

    computed: {
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        }
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>

<style scoped>

</style>
